export interface BridgerRefund {
    response?: {
        status?: string;
        code?: number;
        message?: string;
    };
    result?: {
        refund_transaction_id?: string;
        amount?: number;
        processing_date?: string;
        decline_code?: string;
        decline_reason?: string;
        status?: string;
        currency?: string;
        created_by?: string;
    };
}
